import { configureStore } from "@reduxjs/toolkit";
import selectedStationSlice from "./selectedStationSlice";
import assetsSlice from "./assetsSlice";
import rainGridSlice from "./rainGridSlice";
import mapStateSlice from "./mapStateSlice";
import modalStateSlice from "./modalSlice";
import weatherStationslice from "./weatherStationslice";
import tabSlice from "./tabSlice";
import forecastSlice from "./forecastSlice";
import assetGroupSlice from "./assetGroupSlice";
import userSlice from "./userSlice";
import pCurveSlice from "./pCurveSlice";
import processedModelSchemaSlice from "./processedModelSchemaSlice";
import datasetSlice from "./datasetSlice";

import onboardingSlice, { type OnboardingState } from "./onboardingSlice"; // New onboarding slice added by Mike T

import modelSchemaTemplateSlice from "./modelSchemaTemplateSlice";
import publicProfileSlice from "./publicProfileSlice";
import personaSlice from "./personaSlice";
import clubChecklistSlice from "./clubChecklistSlice";
import systemPromptSlice from "./systemPromptSlice";
import composedForecastSlice from "./composedForecastSlice";
import aiChatSlice, { type AiChatState } from "./aiChatSlice";
import subscriptionSlice, {
  type SubscriptionState,
} from "./subscriptionSlice";
import agentScheduleSlice, {
  type AgentScheduleState,
} from "./agentScheduleSlice";
import projectSlice, { type ProjectState } from "./projectSlice";
import projectChatSlice, { type ProjectChatState } from "./projectChatSlice";
import creatorModeSlice, { type CreatorModeState } from "./creatorModeSlice";

export const store = configureStore({
  reducer: {
    selectedStation: selectedStationSlice,
    assets: assetsSlice,
    rainGrid: rainGridSlice,
    mapState: mapStateSlice,
    modalState: modalStateSlice,
    weatherStation: weatherStationslice,
    tabState: tabSlice,
    forecast: forecastSlice,
    assetGroups: assetGroupSlice,
    user: userSlice,
    pCurve: pCurveSlice,
    processedModelSchemas: processedModelSchemaSlice,
    datasets: datasetSlice,
    onboarding: onboardingSlice, // Registering onboarding slice. mike t
    modelSchemaTemplates: modelSchemaTemplateSlice,
    publicProfile: publicProfileSlice,
    personas: personaSlice,
    clubChecklist: clubChecklistSlice,
    systemPrompts: systemPromptSlice,
    composedForecasts: composedForecastSlice,
    aiChat: aiChatSlice,
    subscription: subscriptionSlice,
    agentSchedule: agentScheduleSlice,
    projects: projectSlice,
    projectChat: projectChatSlice,
    creatorMode: creatorModeSlice,
  },
});

// Export RootState type for TypeScript
export type RootState = ReturnType<typeof store.getState> & {
  onboarding: OnboardingState; // Adding onboarding state type mike t
  aiChat: AiChatState;
  subscription: SubscriptionState;
  agentSchedule: AgentScheduleState;
  projects: ProjectState;
  projectChat: ProjectChatState;
  creatorMode: CreatorModeState;
};
export type AppDispatch = typeof store.dispatch;
